import React from "react";
// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

import Section1 from "../includes/Concord/Section1";
import Section2 from "../includes/Concord/Section2";
import Section3 from "../includes/Concord/Section3";
import Section4 from "../includes/Concord/Section4";
import Section5 from "../includes/Concord/Section5";
import Section6 from "../includes/Concord/Section6";
import Section7 from "../includes/Concord/Section7";

const Concord = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.exddigital.com/concord",
    },
    name: "Concord AI",
    headline: "Document Intelligence and Policy Control Platform",
    // ✅ Added missing description
    description: "Concord AI helps teams stop mismanaging documents by unifying intelligence, security, and policy controls in one secure workflow.",
    image: "https://www.exddigital.com/images/exd_digital.webp",
    author: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        url: "https://www.exddigital.com/images/exd_digital.webp",
      },
    },
    datePublished: "2026-04-15",
    dateModified: "2026-04-15",
  };

  return (
    <>
      <Helmet>
        <title>Concord AI</title>
        <meta
          name="description"
          content="Concord AI helps teams stop mismanaging documents by unifying intelligence, security, and policy controls in one secure workflow."
        />
        <link rel="canonical" href="https://www.exddigital.com/concord" />

        {/* Open Graph */}
        <meta property="og:title" content="Concord AI | ExD Digital" />
        <meta
          property="og:description"
          content="Secure your workflows, reduce risk, and manage documents with intelligent controls."
        />
        <meta property="og:url" content="https://www.exddigital.com/concord" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Concord AI | ExD Digital" />
        <meta
          name="twitter:description"
          content="Secure your workflows, reduce risk, and manage documents with intelligent controls."
        />
        <meta
          name="twitter:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* ✅ Clean — direct JSON.stringify, no spreading */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>

      <main className="our-ai-main">
        <article className="concord">
          <Section1 url={devUrl} />
          <Section2 url={devUrl} />
          <Section7 url={devUrl} />
          <Section3 url={devUrl} />
          <Section4 url={devUrl}/>
          {/* <Section5 url={devUrl} /> */}
          <Section6 url={devUrl}/>
        </article>
      </main>
    </>
  );
};

export default Concord;
